//
// ReportManifest.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";
import "./particles/ReportDataLevel";
import "./particles/ReportAssetURL";
import "./particles/File";
import "@sas-dvr/ltjs-commons/models/particles/Link";
import "./particles/ReportPackageUpdateCharacteristic";

var ReportManifest = createModule("transport_ReportManifest", [130,13,50372,50236,50302], EventDispatcher, [
    ,
    {
        date: 7,
        reportElements: 7,
        updateCharacteristic: 4,
        warnings: 7,
        source: 7,
        locale: 7,
        urls: [1],
        xmlElementName: 7,
        totalSize: 4,
        cacheKey: 7,
        reportStateUri: 7,
        files: [1],
        modifiedTimeStamp: 7,
        formatLocale: 7,
        links: [1],
        dataLevel: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ReportManifest;
